import { IsTruthy } from "@swivl-mono/helpers";
import { Button, ButtonColor } from "@swivl-mono/ui";
import { FaTimes } from "react-icons/fa";
import { BroadcastModal } from "../../../../Components/Conversations/BroadcastModal/BroadcastModal";
import ModalModel from "../../../../Models/Modal/Modal.Model";
import LocationVarsModel from "../../../../Models/Variables/LocationVars.Model";

export function SMSCampaignButton() {
  const vars = LocationVarsModel.useState((s) => s);
  const hasSMSCampaigns = IsTruthy(vars?.orgVariables?.HasSMSCampaigns?.value);

  return (
    <>
      {hasSMSCampaigns && (
        <Button
          color={ButtonColor.ORANGE}
          onClick={() => {
            ModalModel.showModalWithContent(
              <div className="newSmsCampaignButton flex items-center justify-between w-full">
                <h2>New SMS Campaign</h2>
                <a
                  className="closeButton"
                  onClick={() => {
                    ModalModel.hideModal();
                  }}
                >
                  <FaTimes />
                </a>
              </div>,
              <BroadcastModal />,
              544,
              600,
              false,
            );
          }}
        >
          + NEW SMS CAMPAIGN
        </Button>
      )}
    </>
  );
}
